import React, { useState } from 'react';
import { FaChevronRight } from 'react-icons/fa';
import { FiDownload } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

const CallHistoryComponent = ({ viewall,need ,heading,travelData, handleDownloadCSV, dropdownOptions, selectedOption, handleOptionChange }) => {
    const navigate = useNavigate();
    return (
        <div className="min-w-full container mx-auto bg-white shadow-md rounded-lg">
            <div className="bg-white rounded-t-lg p-4 flex md:flex-row sm:flex-col space-y-4 sm:space-y-0 sm:space-x-0 md:space-x-6 items-center self-center">
                <div className="relative md:w-4/6 sm:w-full mb-[15px] md:mb-0">
                    <h2 className="text-xl font-semibold text-left">{heading}</h2>
                </div>
                {need ?
                    <div className="md:mt-0 md:w-3/6 sm:w-full flex sm:flex-row sm:space-x-4 space-y-4 sm:space-y-0">
                        <select
                            value={selectedOption}
                            onChange={handleOptionChange}
                            className="border border-gray-300 rounded-lg px-4 py-2 w-full sm:w-3/6"
                        >
                            <option value="">Select days</option>
                            {dropdownOptions.map(option => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>

                        <button
                            onClick={handleDownloadCSV}
                            className="p-2 bg-gray-200 rounded-md flex items-center space-x-1 w-full sm:w-3/6 justify-center"
                        >
                            <span>Download CSV</span>
                            <FiDownload className="w-4 h-4" />
                        </button>
                    </div>
                    : null}
            </div>
            <div className="overflow-x-auto bg-white rounded-b-lg">
                <table className="min-w-full overflow-hidden">
                    <thead className="bg-gray-100">
                        <tr className="bg-gray-100 text-left">
                            <th className="px-4 p-4 text-left text-sm font-medium text-gray-600 min-w-[150px]">Lead Name</th>
                            <th className="px-4 p-4 text-left text-sm font-medium text-gray-600 min-w-[150px]">Purpose Of Call</th>
                            <th className="px-4 p-4 text-left text-sm font-medium text-gray-600 min-w-[120px]">Call Duration</th>
                            <th className="px-4 p-4 text-left text-sm font-medium text-gray-600 min-w-[120px]">Time</th>
                            <th className="px-4 p-4 text-left text-sm font-medium text-gray-600 min-w-[120px]">Date</th>
                        </tr>
                    </thead>
                    <tbody className="text-sm text-gray-800">
                        {travelData.map((row, idx) => (
                            <tr key={idx} className="border-b last:border-none">
                                <td className="p-4 text-gray-800">{row.name}</td>
                                <td className="p-4 text-gray-800">{row.purpose}</td>
                                <td className="p-4 text-gray-800">{row.duration}</td>
                                <td className="p-4 text-gray-800">{row.time}</td>
                                <td className="p-4 text-gray-800">{row.date}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {viewall ?
                <div className="p-4 py-6 flex justify-end">
                    <a onClick={() => {
                        navigate('/call-history');

                    }} className="text-sm text-black flex items-center">
                        View All <FaChevronRight className="ml-1" />
                    </a>
                </div>
                :
                <div className=" pb-2">
                </div>
            }
        </div>
    );
};

export default CallHistoryComponent;
